// extracted by mini-css-extract-plugin
module.exports = {"stores":"Stores_stores__FuiNu","stores__title":"Stores_stores__title___uC0e","stores__content":"Stores_stores__content__VNPzz"};